import type { TFunction } from "i18next";
import { SmartphoneIcon, MailIcon } from "lucide-react";

import { SupportTicketChannel } from "~/graphql/graphql.gen";

export const getTicketChannels = (t: TFunction) => [
  {
    value: SupportTicketChannel.AppChat,
    label: t("ticket.channel.app_chat"),
    icon: SmartphoneIcon,
  },
  {
    value: SupportTicketChannel.Email,
    label: t("ticket.channel.email"),
    icon: MailIcon,
  },
];

export const mapFilterToChannel = (filter: string) => {
  return filter as SupportTicketChannel;
};

export const mapChannelToFilter = (channel: SupportTicketChannel) => {
  return channel as string;
};
